import { render, staticRenderFns } from "./PublicationHeader.vue?vue&type=template&id=6e04ae3a&scoped=true&lang=pug"
import script from "./PublicationHeader.vue?vue&type=script&lang=js"
export * from "./PublicationHeader.vue?vue&type=script&lang=js"
import style0 from "./PublicationHeader.vue?vue&type=style&index=0&id=6e04ae3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e04ae3a",
  null
  
)

export default component.exports